import { render, staticRenderFns } from "./Educational.vue?vue&type=template&id=50ae0276&scoped=true&"
import script from "./Educational.vue?vue&type=script&lang=js&"
export * from "./Educational.vue?vue&type=script&lang=js&"
import style0 from "./Educational.vue?vue&type=style&index=0&id=50ae0276&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ae0276",
  null
  
)

export default component.exports